export enum IdentityVerificationMethodsEnum {
  BASIC = 'BASIC',
  NATIONAL_NODE = 'NATIONAL_NODE',
  ONLINE = 'ONLINE'
}
